'use client'

import { Search24 } from '@vinted/monochrome-icons'
import { Icon, InputText } from '@vinted/web-ui'
import { FormEvent, useRef } from 'react'
import { v4 as uuid } from 'uuid'

import { navigateToPage } from '@marketplace-web/browser/browser-navigation-util'
import { cookiesDataByName, useCookie } from '@marketplace-web/environment/cookies-util'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { urlWithParams } from '@marketplace-web/shared/utils'
import { AccessChannel } from '@marketplace-web/help-center/help-center-faq-entry-url-data'

import { HELP_SEARCH_URL } from '../constants/routes'

const HelpCenterSearchInput = () => {
  const translate = useTranslate('help_center')

  const searchRef = useRef<HTMLInputElement>(null)
  const cookies = useCookie()

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const searchTerm = searchRef.current?.value

    if (!searchTerm) return
    cookies.set(cookiesDataByName.help_center_search_session_id, uuid())

    navigateToPage(
      urlWithParams(HELP_SEARCH_URL, {
        search_text: searchTerm,
        access_channel: AccessChannel.HcSearch,
      }),
    )
  }

  const renderSearchIcon = () => (
    <button type="submit">
      <Icon
        name={Search24}
        color={Icon.Color.GreyscaleLevel2}
        aria={{ 'aria-label': translate('a11y.search_button') }}
      />
    </button>
  )

  return (
    <form onSubmit={handleSubmit} className="faq-search">
      <InputText
        name="help-center-search"
        styling={InputText.Styling.Wide}
        placeholder={translate('search_field_placeholder')}
        inputMode={InputText.InputMode.Search}
        ref={searchRef}
        data-testId="help-center-search-text"
        suffix={renderSearchIcon()}
      />
    </form>
  )
}

export default HelpCenterSearchInput
